module.exports = __webpack_public_path__ + "static/media/done_tick.e261b761.svg";